import { render } from "./TopHeader.vue?vue&type=template&id=8296b3a0&scoped=true"
import script from "./TopHeader.vue?vue&type=script&lang=js"
export * from "./TopHeader.vue?vue&type=script&lang=js"

import "./TopHeader.scss?vue&type=style&index=0&id=8296b3a0&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8296b3a0"]])

export default __exports__